import axios from 'axios';
import AxiosConfig from '../utils/axios';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  /**
   * Delete source
   *
   * @param {number} sourceId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  deleteSource(sourceId, applicationNamespace) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${apiUrl}/v1/${applicationNamespace}/sources/${sourceId}`,
          AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE),
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  /**
   * Get the encoded data for a specfic pdf to show in the fileviewer
   *
   * @param {number} sourceId
   * @param {string} applicationNamespace
   * @returns {Promise}
   */
  getSource(sourceId, applicationNamespace) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${apiUrl}/v1/${applicationNamespace}/sources/${sourceId}`,
          AxiosConfig.getConfig(process.env.VUE_APP_COOKIE_NAMESPACE),
        )
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};
